import { useEffect, useState } from 'react';
import { SunkenBox } from '@ewf/components/SunkenBox';
import { Button } from '@ewf/components/Button';
import { CloseButton } from '@ewf/components/ModalUI/CloseButton';
import { useApiServiceStore } from '@ewf/stores/api';

export const Confirm = ({ onConfirm, onClose }: Props): React.ReactNode => {
  const [linkedWorkerAccount, setLinkedWorkerAccount] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'error'>('idle');
  const workerApi = useApiServiceStore.getState().api;

  useEffect(() => {
    setStatus('loading');
    workerApi
      .getLinkedWorkerNode()
      .then((currentLinkedWorkerAccount) => {
        if (currentLinkedWorkerAccount) {
          setLinkedWorkerAccount(currentLinkedWorkerAccount);
        }
      })
      .catch((error) => {
        console.error(error);
        setStatus('error');
      })
      .finally(() => setStatus('idle'));
  }, [workerApi]);

  return (
    <div className="w-[550px] rounded-lg border-2 border-transparent p-8 gradient-border-secondary-with-gray-90">
      <section className="relative mb-8 flex h-[40px] justify-end">
        <CloseButton onClick={onClose} />
      </section>
      <section className="mb-8 rounded-lg p-6 bg-popup-gradient">
        <SunkenBox className="px-8 text-center">
          <h3 className="font-primary-bold text-lg uppercase text-red">Important information</h3>
          <hr className="my-3 border border-b border-gray-70" />
          <p className="mb-2 font-primary">
            You are about to unlink your operator account from this worker account{' '}
          </p>
          <div className="my-6 w-full items-center justify-center gap-3 rounded-md border-[1px] border-transparent py-3 pl-2 text-center text-sm text-white shadow-sunken gradient-border-secondary-with-gray-90">
            <span>{status === 'loading' ? 'Loading...' : linkedWorkerAccount}</span>
          </div>
          <p className="mb-2">
            Click &quot;Unlink&quot; to proceed with this action or &quot;Cancel&quot; to close this
            dialog.
          </p>
          {/* <br></br> */}
          <hr className="my-3 border border-b border-gray-70" />
          <h4 className="mb-3 text-sm font-bold uppercase text-red">Disclaimer</h4>
          <p className="text-sm">
            You will be asked to link your operator account with a worker account if you wish to
            enable a worker in the future.
          </p>
        </SunkenBox>
      </section>
      <section className="flex justify-center gap-8">
        <Button onClick={onClose} color="outlined">
          Cancel
        </Button>
        <Button onClick={onConfirm}>Unlink</Button>
      </section>
    </div>
  );
};

interface Props {
  onConfirm: () => void;
  onClose: () => void;
}
